<template>
  <!-- <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul class="ul_menu" style="list-style: none">
      <li
        :class="{ topmenuactive: activeTab === 'ThietBiTab' }"
        @click="changeTab('ThietBiTab')"
      >
        <a class="urlThietBi">{{
          currentLanguage.header_text_thietBi_thietBi
        }}</a>
      </li>
      <li
        :class="{ topmenuactive: activeTab === 'DaiLy' }"
        @click="changeTab('DaiLy')"
      >
        <a class="urlDaiLy">{{ currentLanguage.header_text_thietBi_daiLy }}</a>
      </li>
    </ul>
  </nav> -->
  <div class="wrapper row3">
    <main class="hoc container-fluid clear bv p-0">
      <div class="wrapper row3">
        <main class="hoc container-fluid clear bv p-0">
          <!-- gioi thieu -->
          <div v-show="showThietBiTab" style="min-height: 500px" class="padding-top15">
            <div id="giathietbi" class="tabcontent" style="display: block">
              <table cellspacing="0" border="0">
                <tbody class="tbody_table_css_tb">
                  <tr style="
                      background: #85c8eb;
                      height: 30px;
                      line-height: 10px;
                      text-align: center;
                    ">
                    <!-- <td class="td_tb_1_1">
                      <b>{{ currentLanguage.body_text_thietbi_tb_Ten }}</b>
                    </td> -->
                    <td class="td_tb_2_1" style="vertical-align: middle; text-align: center">
                      <b>{{
                        currentLanguage.body_text_thietbi_tb_Thietbibaohanh2nam
                      }}</b>
                    </td>
                    <td class="td_tb_3_1" style="vertical-align: middle; text-align: center">
                      <!-- <b>{{ currentLanguage.body_text_thietbi_tb_Ungdung }}</b> -->
                      <b> Nhà sản xuất</b>
                    </td>
                    <td class="td_tb_4_1" style="vertical-align: middle; text-align: center">
                      <b>{{
                        currentLanguage.body_text_thietbi_tb_Tinhnangkythuat
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_tb_2_1" style="vertical-align: middle">
                      <p class="text_p" style="font-weight: 600">
                        QR thanh toán ép plastic và đế mica
                      </p>
                      <ul class="gallery flex" style="display: flex; flex-wrap: wrap">
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763097347927Rjm6F">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763097347927Rjm6F" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763105797808MQWCF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763105797808MQWCF" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763105882986kTECF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763105882986kTECF" />
                          </a>
                        </li>
                        <!-- <li><iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen frameborder="0" height="56" width="35" src="https://www.youtube.com/embed/_2BPZGodut4"> </iframe> </li> -->

                      </ul>
                      <p class="text_p">
                        QR thanh toán ép plastic - Giá: 8.000 đồng
                      </p>
                      <p class="text_p">

                        Đế mica đặt QR thanh toán - Giá: 30.000 đồng

                      </p>
                      <!-- <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p> -->
                    </td>
                    <td class="td_tb_3_1">

                    </td>
                    <td class="td_tb_4_1">

                    </td>

                  </tr>
                  <tr>
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.header_text_theChip }}
                      </p>
                      <ul class="gallery flex">
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757663345769omKsF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757663345769omKsF" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757663345629eXoaF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757663345629eXoaF" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1765180710515SlFwF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1765180710515SlFwF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_Gia100000dongthe
                        }}<br />

                        {{
                          currentLanguage.body_text_thietbi_tb_Giataitro50000
                        }}
                      </p>

                      <p style="font-weight: normal">
                        {{
                          currentLanguage.body_text_thietbi_tb_Tangkembaodungthe
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://drive.google.com/file/d/1l332q03HuwZOjnuuIoFBJyZtCznYYVjo/view?usp=sharing">{{
                            currentLanguage.body_text_thietbi_tb_NXPKetnoiantoanchomotthegioithongminh
                          }}<br /></a>
                      </p>
                      <p>
                        <a target="_blank" href="https://vimass.vn/vmbank/services/media/viewFile?id=NXP_UCODE.pdf"></a>
                      </p>

                      <p>
                        <a target="_blank"
                          href="https://www.nxp.com/company/about-nxp/investor-relations:INVESTOR-RELATIONS">{{
                            currentLanguage.body_text_thietbi_tb_Chitiettunhasanxuat
                          }}</a>
                      </p>
                    </td>
                    <td class="td_tb_4_1">
                      <p>
                        <a href="https://www.nxp.com/docs/en/data-sheet/MF3D_H_X3_SDS.pdf" target="_blank">{{
                          currentLanguage.body_text_thietbi_tb_MIFAREDESFireEV3ApplicationKeyFile
                        }}</a>
                      </p>
                      <p>
                        <a href="https://www.nxp.com/assets/block-diagram/en/MF3DHx3.pdf" target="_blank">{{
                          currentLanguage.body_text_thietbi_tb_MIFAREDESFireEV3ICBlockdiagram
                        }}</a>
                      </p>
                      <p>
                        <a target="_blank" href="https://www.nxp.com/docs/en/fact-sheet/MFDFLFEV3.pdf">{{
                          currentLanguage.body_text_thietbi_tb_TailieukythuatveChipMifareDESFireEV38KB
                        }}</a>
                      </p>

                      <p>
                        <a target="_blank" href="https://www.nxp.com/docs/en/fact-sheet/UCODE9FSA4.pdf">{{
                          currentLanguage.body_text_thietbi_tb_TailieukythuatveUCODE9
                        }}</a>
                      </p>
                      <!-- <p>
                        <a
                          target="_blank"
                          href="https://vimass.vn/vmbank/services/media/viewFile?id=MF3DHx3_SDS-VN.pdf"
                        >
                          {{
                            currentLanguage.body_text_thietbi_tb_TinhNangBaoMatEV3
                          }}</a
                        >
                      </p> -->
                    </td>
                  </tr>

                  <tr>
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_The2chip }}
                      </p>
                      <ul class="gallery flex">
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1697193212852l137F">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1697193212852l137F" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1697193308643RxMAF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1697193308643RxMAF" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1765180677682FxOzF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1765180677682FxOzF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_Gia100000160000dongthe
                        }}<br />

                        {{
                          currentLanguage.body_text_thietbi_tb_Giataitro80000
                        }}
                      </p>

                      <p style="font-weight: normal">
                        {{
                          currentLanguage.body_text_thietbi_tb_Tangkembaodungthe
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://drive.google.com/file/d/1l332q03HuwZOjnuuIoFBJyZtCznYYVjo/view?usp=sharing">{{
                            currentLanguage.body_text_thietbi_tb_NXPKetnoiantoanchomotthegioithongminh
                          }}<br /></a>
                      </p>
                      <p>
                        <a target="_blank" href="https://vimass.vn/vmbank/services/media/viewFile?id=NXP_UCODE.pdf"></a>
                      </p>

                      <p>
                        <a target="_blank"
                          href="https://www.nxp.com/company/about-nxp/investor-relations:INVESTOR-RELATIONS">{{
                            currentLanguage.body_text_thietbi_tb_Chitiettunhasanxuat
                          }}</a>
                      </p>
                    </td>
                    <td class="td_tb_4_1">
                      <p>
                        <a href="https://www.nxp.com/docs/en/data-sheet/MF3D_H_X3_SDS.pdf" target="_blank">{{
                          currentLanguage.body_text_thietbi_tb_MIFAREDESFireEV3ApplicationKeyFile
                        }}</a>
                      </p>
                      <p>
                        <a href="https://www.nxp.com/assets/block-diagram/en/MF3DHx3.pdf" target="_blank">{{
                          currentLanguage.body_text_thietbi_tb_MIFAREDESFireEV3ICBlockdiagram
                        }}</a>
                      </p>
                      <p>
                        <a target="_blank" href="https://www.nxp.com/docs/en/fact-sheet/MFDFLFEV3.pdf">{{
                          currentLanguage.body_text_thietbi_tb_TailieukythuatveChipMifareDESFireEV38KB
                        }}</a>
                      </p>

                      <p>
                        <a target="_blank" href="https://www.nxp.com/docs/en/fact-sheet/UCODE9FSA4.pdf">{{
                          currentLanguage.body_text_thietbi_tb_TailieukythuatveUCODE9
                        }}</a>
                      </p>
                      <!-- <p>
                        <a
                          target="_blank"
                          href="https://vimass.vn/vmbank/services/media/viewFile?id=MF3DHx3_SDS-VN.pdf"
                        >
                          {{
                            currentLanguage.body_text_thietbi_tb_TinhNangBaoMatEV3
                          }}</a
                        >
                      </p> -->
                    </td>
                  </tr>
                  <!-- thiet bi ban tay -->
                  <tr>
                    <td class="td_tb_2_1" style="vertical-align: middle">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_ThietBiBanTay }}
                      </p>
                      <ul class="gallery flex" style="display: flex; flex-wrap: wrap">
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763181176099yRvXF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763181176099yRvXF" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=176318117617845B3F">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=176318117617845B3F" />
                          </a>
                        </li>
                        <!-- <li><iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen frameborder="0" height="56" width="35" src="https://www.youtube.com/embed/_2BPZGodut4"> </iframe> </li> -->
                        <li>
                          <a target="_blank" href="https://www.youtube.com/embed/_2BPZGodut4">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1763181448080wJwZF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Giabantay }}
                      </p>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT2trdong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <!-- <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_XacThucBanTay
                        }}
                      </p>  -->
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_TocDoXacThucBanTay
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Nhandang10000bantay
                        }}
                      </p>
                      <p>
                        {{ currentLanguage.body_text_thietbi_tb_FFR }}
                      </p>
                      <p>
                        <a href="https://ai.vimass.vn/search/Thiet-bi-nhan-dang-tinh-mach-ban-tay-don-sac-do-cong-ty-Shenzhen-Tendcent-Technology-san-xuat-voi-don-gia-40-USD-cai-mua-200-cai-trong-1-hop-dong-co-phai-loai-nhan-biet-1-trong-10000-ban-tay-duoi-1-giay-nhan-biet-1-trong-50000-ban-tay-duoi-2-giay-voi-ty-le-sai-sot-001-khong-Co-cong-ty-nao-khac-o-Trung-Quoc-ban-thiet-bi-tuong-tu-nhung-tinh-nang-tot-hon-hoac-gia-re-hon-khong-R1756980730118DTl?mode=view"
                          target="_blank">{{
                            currentLanguage.body_text_thietbi_tb_thongTinBanTay
                          }}</a>
                      </p>
                      <p>
                        <a href="https://drive.google.com/file/d/1CBQiIh0jUYCupmSoO4gT69FJX3LokchT/view"
                          target="_blank">{{
                            currentLanguage.body_text_thietbi_tb_ThongsoBantay
                          }}</a>
                      </p>
                      <p>
                        <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757064523874giRwF"
                          target="_blank">{{
                            currentLanguage.body_text_thietbi_tb_Hopdongmuabanbantay
                          }}</a>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_VPhone22 }}
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank" href="img/thietbi/VP1.jpg">
                              <img loading="lazy" src="img/thietbi/VP1.jpg" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank" href="img/thietbi/VP2.jpg">
                              <img loading="lazy" src="img/thietbi/VP2.jpg" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank" href="img/thietbi/VP3.jpg">
                              <img loading="lazy" src="img/thietbi/VP3.jpg" />
                            </a>
                          </li>
                        </ul>
                        <div>
                          <!-- <a target="_blank" href="https://www_youtube_com/watch?v=zTV5_uhLTHA">
                                                <img loading="lazy" src="@routes_Assets_at("images/img_videoVphone_JPG}}">
                                            </a> -->
                        </div>
                      </div>

                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT3000000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiabantaitroVphone
                        }}
                      </p>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <div style="display: flex; width: 100%">
                        <div style="width: 50%">
                          <!-- <p>
                            <a
                              target="_blank"
                              href="https://vimass.vn/vmbank/services/media/viewFile?id=VPhone_22_GSM_Association.pdf"
                              >{{
                                currentLanguage.body_text_thietbi_tb_VPhone22GSMAssociation
                              }}</a
                            >
                          </p> -->
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_ManHinh653inch19201200HD
                            }}
                          </p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_Front5MPBack13MP
                            }}
                          </p>
                          <p>
                            {{ currentLanguage.body_text_thietbi_tb_RAM3GB }}
                          </p>
                          <p>{{ currentLanguage.body_text_thietbi_tb_nfc }}</p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_Dungluongluutru32GB
                            }}
                          </p>
                          <p>
                            <a target="_blank"
                              href="https://drive.google.com/file/d/1IX133wmVRB3FqkjRgyWespEghhIVktk3/view?usp=sharing">{{
                                currentLanguage.body_text_thietbi_tb_thongsokythuatVPhone22
                              }}</a>
                          </p>
                          <!-- <p>
                            <a
                              target="_blank"
                              href="https://vimass.vn/vmbank/services/media/viewFile?id=MT6762D_LTE-A_Smartphone_Application_Processor_Technical_Brief_V1.pdf"
                              >{{
                                currentLanguage.body_text_thietbi_tb_MT6762DCPU
                              }}</a
                            >
                          </p>

                          <p>
                            <a
                              target="_blank"
                              href="https://vimass.vn/vmbank/services/media/viewFile?id=schematic_diagram_F699D_MT6762_V1.0_SCH.pdf"
                              >{{
                                currentLanguage.body_text_thietbi_tb_TechnicaldiagramMT6762
                              }}</a
                            >
                          </p>
                          <p>
                            <a
                              target="_blank"
                              href="https://vimass.vn/vmbank/services/media/viewFile?id=MTK6762_SC9863.pdf"
                              >{{
                                currentLanguage.body_text_thietbi_tb_CompareCPUMT6762DwithSC9863
                              }}</a
                            >
                          </p>
                          <p>
                            <a
                              target="_blank"
                              href="https://vimass.vn/vmbank/services/media/viewFile?id=User_Manual.pdf"
                              >{{
                                currentLanguage.body_text_thietbi_tb_UserManual
                              }}</a
                            >
                          </p> -->
                        </div>
                        <!-- <div style="width: 50%">
                          <p style="font-weight: 600">
                            {{
                              currentLanguage.body_text_thietbi_tb_MotsodienthoaicoNFC
                            }}
                          </p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_SamsungGalaxyM22
                            }}
                          </p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_SamsungGalaxyA32
                            }}
                          </p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_DienthoaiSamsungGalaxyNFC
                            }}
                          </p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_SamsungGalaxyS6trolen
                            }}
                          </p>
                          <p>
                            {{
                              currentLanguage.body_text_thietbi_tb_IPhone7trolen
                            }}
                          </p>
                        </div> -->
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_VTablet22 }}
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454671357NzwtF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454671357NzwtF" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17023563899276JHNF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17023563899276JHNF" />
                            </a>
                          </li>
                        </ul>
                        <div>
                          <a target="_blank" href="https://www_youtube_com/watch?v=sT16PcTeoM4">
                            <!-- <img loading="lazy" src="@routes_Assets_at("images/img_videoVtalet_JPG}}"> -->
                          </a>
                        </div>
                      </div>

                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT3200000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiabantaitroVtab
                        }}
                      </p>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_ManHinh101inch19201200HD
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Front5MPBack8MP
                        }}
                      </p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_RAM3GB }}</p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_nfc }}</p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Dungluongluutru32GB
                        }}
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://drive.google.com/file/d/1us3jOBH7zwODn01IzITO96VWJr46CwW6/view?usp=sharing">{{
                            currentLanguage.body_text_thietbi_tb_ThongsokythuatVTablet22
                          }}</a>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_The3chipkyso }}
                      </p>
                      <ul class="gallery flex">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670451wqXRF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670451wqXRF" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17024546705456qkSF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17024546705456qkSF" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356388240eBSUF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356388240eBSUF" />
                            </a>
                          </li>
                        </ul>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_Gia150000210000dongthe
                        }}
                        <br />
                        <!-- {{
                          currentLanguage.body_text_thietbi_tb_Giataitro130000
                        }} -->
                      </p>
                      <p style="font-weight: normal">
                        {{
                          currentLanguage.body_text_thietbi_tb_Tangkembaodungthe
                        }}
                      </p>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <p>
                        <a target="_blank" :href="currentLanguage.body_text_thietbi_tb_LinkNXP">{{
                          currentLanguage.body_text_thietbi_tb_NXPKetnoiantoanchomotthegioithongminh
                        }}<br /></a>
                      </p>
                      <p>
                        <a target="_blank" href="https://vimass.vn/vmbank/services/media/viewFile?id=NXP_UCODE.pdf"></a>
                      </p>

                      <p>
                        <a target="_blank" href="https://www.acs.com.hk/en/">{{
                          currentLanguage.body_text_thietbi_tb_ChitiettunhasanxuatAdvanced
                        }}</a>
                      </p>
                    </td>
                    <td class="td_tb_4_1">
                      <p>
                        <a href="https://www.nxp.com/assets/block-diagram/en/MF3DHx3.pdf" target="_blank">{{
                          currentLanguage.body_text_thietbi_tb_MIFAREDESFireEV3ICBlockdiagram
                        }}</a>
                      </p>
                      <p>
                        <a href="https://www.nxp.com/docs/en/data-sheet/MF3D_H_X3_SDS.pdf" target="_blank">{{
                          currentLanguage.body_text_thietbi_tb_MIFAREDESFireEV3ApplicationKeyFile
                        }}</a>
                      </p>

                      <p>
                        <a target="_blank" href="https://www.nxp.com/docs/en/fact-sheet/MFDFLFEV3.pdf">{{
                          currentLanguage.body_text_thietbi_tb_TailieukythuatveChipMifareDESFireEV38KB
                        }}
                        </a>
                      </p>
                      <p>
                        <a target="_blank" href="https://www.nxp.com/docs/en/fact-sheet/UCODE9FSA4.pdf">{{
                          currentLanguage.body_text_thietbi_tb_TailieukythuatveUCODE9
                        }}</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.acs.com.hk/en/products/308/acos5-64-v3_00-cryptographic-card-contact/">{{
                            currentLanguage.body_text_thietbi_tb_UngdungcuachipkysoACOS564
                          }}</a>
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1" style="vertical-align: middle">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_VReader }}
                      </p>
                      <ul class="gallery flex" style="display: flex; flex-wrap: wrap">
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1706781154552Gr2EF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1706781154552Gr2EF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT1850000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Cambienvantay5mucdobaomatluutrutoida1000mauvantay
                        }}
                      </p>

                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Cambienquanghoc
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Thoigiannhandang
                        }}
                      </p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_ip67 }}</p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_Thongso }}</p>
                      <p>
                        <a href="https://www.secukey.net/Product/Access_Control/Biometric_Access/139.html"
                          target="_blank">https://www.secukey.net/Product/Access_Control/Biometric_Access/139.html</a>
                      </p>
                    </td>
                  </tr>
                  <!-- <tr>

                    <td class="td_tb_2_1" style="vertical-align: middle">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_VReader }} 3000
                      </p>
                      <ul class="gallery flex" style="display: flex; flex-wrap: wrap">
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1706781154552Gr2EF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1706781154552Gr2EF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT2200000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Cambienvantay5mucdobaomatluutrutoida3000mauvantay
                        }}
                      </p>

                      <p>{{ currentLanguage.body_text_thietbi_tb_Cambienquanghoc }}</p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_Thoigiannhandang }}</p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_ip67 }}</p>
                      <p>{{ currentLanguage.body_text_thietbi_tb_Thongso }}</p>
                      <p><a href="https://www.secukey.net/Product/Access_Control/Biometric_Access/139.html"
                          target="_blank">https://www.secukey.net/Product/Access_Control/Biometric_Access/139.html</a>
                      </p>
                    </td>
                  </tr> -->
                  <tr>
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_TemUCODERFid }}
                      </p>
                      <div style="display: flex; justify-content: center">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17023563900055xE8F">
                              <img loading="lazy" width="100px"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17023563900055xE8F" />
                            </a>
                          </li>

                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356390083585uF">
                              <img loading="lazy" width="100px"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356390083585uF" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356390161V2UyF">
                              <img loading="lazy" width="100px"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356390161V2UyF" />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT30000den60000dong
                        }}
                        <br />
                        {{
                          currentLanguage.body_text_thietbi_tb_Giataitro20000
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Bankemthedanang1themuatoida2nhan
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_SudungdanotoxemmaycothethaythetheVETCEpassbihong
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_DungungdungQRVietnamdeghimaEPC
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_KhongtrungvoimaEPCdacocuaVimass
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_PhaitrungvoimakhachdangsudungcuadonvikhacVETCEpass
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Kichthuocanten70x14mm
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_ChatlieuGiaytrang
                        }}
                      </p>
                    </td>

                    <td class="td_tb_4_1">
                      {{ currentLanguage.body_text_thietbi_tb_thongsokythuat }}

                      <p class="text_p">
                        - UCODE® 9 Accelerates the IoT
                        <a target="_blank" href="https://www.nxp.com/products/SL3S1206FUD2">
                          (https://www.nxp.com/products/SL3S1206FUD2)</a>
                      </p>
                      <p class="text_p">
                        - UCODE 8/8m
                        <a target="_blank" href="https://www.nxp.com/products/SL3S1205-15">
                          (https://www.nxp.com/products/SL3S1205-15)</a>
                      </p>
                    </td>
                  </tr>

                  <tr id="pcmini">
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_Maytinhmini7000000
                        }}
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751602189577wh4gF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751602189577wh4gF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751602189514LYaVF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751602189514LYaVF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17516021894056IGLF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17516021894056IGLF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Gia7000000 }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_CPUCeleronN5105Upto29GHz4Cores4
                        }}
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_VGAIntelUHDGraphics
                        }}
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://memoryzone.com.vn/ram-laptop-kingston-ddr5-16gb-5600mhz-1-1v-kvr56s46bs8-16?utm_source=Website&utm_medium=TopSearch">
                          {{ currentLanguage.body_text_thietbi_tb_Ram8GB }}
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://memoryzone.com.vn/ssd-western-digital-blue-sn580-1tb-pcie-gen4-x4-nvme-m-2-wds100t3b0e?utm_source=Website&utm_medium=TopSearch">
                          {{ currentLanguage.body_text_thietbi_tb_Ocung2TB }}
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://memoryzone.com.vn/may-tinh-mini-pc-asus-nuc-14-essential-mill-canyon-n97-rnuc14mnk9700000?variantid=133160261">
                          {{
                            currentLanguage.body_text_thietbi_tb_httpsmemoryzonecomvnmaytinhminipcintelnuc11essentialkitatlascanyonceleronn5105bnuc11atkc40000variantid69490990
                          }}</a>
                      </p>
                    </td>
                  </tr>
                  <tr id="pci7">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        Máy tính CPU i7 12 lõi
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454671263Y4OjF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454671263Y4OjF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670248L6TcF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670248L6TcF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356388052UavOF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356388052UavOF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670154TSKcF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670154TSKcF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Gia22374000 }}
                      </p>
                      <p class="text_p">Bảo hành: tối thiểu 12 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a href="https://hacom.vn/cpu-intel-core-i7-12700f" target="_blank">
                          CPU Intel Core i7-12700F (Up to 4.8Ghz, 12 nhân 20
                          luồng, 25MB Cache, 125W) - Socket Intel LGA 1700)
                        </a>
                      </p>
                      <p>
                        RAM: từ
                        <a target="_blank"
                          href="https://hacom.vn/ram-kingston-fury-beast-rgb-8gb-ddr4-3200mhz-kf432c16bb2a-8">
                          8GB </a>đến
                        <a target="_blank"
                          href="https://hacom.vn/ram-kingston-fury-beast-rgb-32gb-ddr4-3200mhz-kf432c16bb12ak2-32-kf432c16bb2ak2-32">32GB
                        </a>
                      </p>
                      <p>
                        SSD từ
                        <a target="_blank"
                          href="https://memoryzone.com.vn/ssd-kingston-nv2-m-2-pcie-gen4-x4-nvme-2tb-snv2s-2000g?variantId=75058432">
                          8GB đến 32GB
                        </a>
                      </p>
                      <!-- <p><a target="_blank" href="https://hacom.vn/tan-nhiet-khi-deepcool-ak400">Mainboard ASUS PRIME
                          B760M-A WIFI D4
                          . Tản nhiệt khí DEEPCOOL AK400
                          Nguồn Cooler master MWE 750 BRONZE - V2 230V 750w
                          Vỏ Case KENOO ESPORT FM800 </a>
                      </p> -->

                      <p>
                        <a target="_blank"
                          href="https://hacom.vn/mainboard-asus-prime-b760m-a-wifi-d4?gclid=Cj0KCQjwoK2mBhDzARIsADGbjepePjhdgkY484rftjrNyFbrm2hs3krr0OC55YOhvkyP37d9WTLyAgYaAjz2EALw_wcB">
                          Mainboard ASUS PRIME B760M-A WIFI D4</a>
                      </p>
                      <p>
                        <a target="_blank" href="https://hacom.vn/tan-nhiet-khi-deepcool-ak400">
                          Tản nhiệt khí DEEPCOOL AK400</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.anphatpc.com.vn/nguon-cooler-master-mwe-750-bronze-v2-230v-750w.html">
                          Nguồn Cooler master MWE 750 BRONZE - V2 230V 750w</a>
                      </p>
                      <p>
                        <a target="_blank" href="https://hacom.vn/vo-case-kenoo-esport-fm800">
                          Vỏ Case KENOO ESPORT FM800
                        </a>
                      </p>
                      <!-- <p>
                        Bảo hành: tối thiểu 12 tháng
                      </p> -->
                    </td>
                  </tr>
                  <tr id="pci9">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600" v-html="currentLanguage.body_text_thietbi_tb_MaytinCPUI9
                        "></p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF" />
                            </a>
                          </li>
                          <!-- <li>
                                                    <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751612874965hcutF" target="_blank">
                                                        <img loading="lazy" src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751612874965hcutF" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF" target="_blank">
                                                        <img loading="lazy" src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF" />
                                                    </a>
                                                </li> -->
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Gia139950000 }}
                      </p>
                      <p class="text_p">Bảo hành: tối thiểu 12 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://hacom.vn/cpu-intel-core-ultra-9-285k-up-to-5.5ghz-24-nhan-24-luong-36mb-cache-125w-socket-intel-lga-1851-arrow-lake">
                          CPU Intel Core Ultra 9 285K (UP TO 5.5Ghz, 24 NHÂN 24
                          LUỒNG, 36MB CACHE, 125W) - Socket Intel LGA 1851/ARROW
                          LAKE
                        </a>
                      </p>

                      <p>
                        Có thể sử dụng đồng thời 2 card
                        <a target="_blank" href="https://hacom.vn/card-man-hinh-asus-tuf-rtx-5090-32g-gddr7">
                          RTX5090</a>
                      </p>
                      <p>
                        RAM:
                        <a target="_blank"
                          href="https://hacom.vn/ram-corsair-dominator-platinum-rgb-white-96gb-ddr5-6600mhz-cmp96gx5m2b6600c32w">
                          192GB
                        </a>
                      </p>
                      <p>
                        SSD
                        <a target="_blank"
                          href="https://memoryzone.com.vn/ssd-corsair-mp600-pro-xt-8tb-m-2-pcie-gen4-x4-nvme-1-4-cssd-f8000gbmp600pxt">
                          16TB
                        </a>
                      </p>
                      <p>
                        <a target="_blank" href="https://hacom.vn/mainboard-asus-tuf-gaming-z890-plus-wifi-ddr5">
                          Mainboard ASUS TUF GAMING Z890-PLUS WIFI DDR5</a>
                      </p>
                      <p>
                        <a target="_blank" href="https://hacom.vn/tan-nhiet-nuoc-corsair-nautilus-360-argb-black">
                          Tản nhiệt nước Corsair NAUTILUS 360 ARGB - Black</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://hacom.vn/nguon-asus-tuf-gaming-1200w-gold-atx3.0-pci-gen-5.0-80-plus-gold-mau-den-full-modular">
                          Nguồn Asus TUF Gaming 1200W Gold ATX3.0</a>
                      </p>
                      <p>
                        <a target="_blank" href="https://hacom.vn/vo-case-xigmatek-osiris-pro-4fx-eatx-4fan">
                          Vỏ case XIGMATEK OSIRIS Pro 4FX
                        </a>
                      </p>
                      <!-- <p><a target="_blank" href="https://ai.vimass.vn/search/Tinh-nang-ky-thuat-cua-GPU-NVidia-5090-va-A10-R1758602531677mGv?mode=view">
                                                Tính năng kỹ thuật của GPU NVidia 5090 và A10 </a>
                                        </p>
                                        <p><a target="_blank" href="https://ai.vimass.vn/search/He-dieu-hanh-CUDA-cua-NVIDIA-va-Bo-thu-vien-ma-nguon-mo-CUDA-su-dung-hieu-qua-nhat-voi-GPU-NVIDIA-RTX-5070-va-RTX-5090-R17586023554405lb?mode=view">
                                                Hệ điều hành CUDA của NVIDIA và Bộ thư viện mã nguồn mở CUDA với GPU NVIDIA RTX 5070 và RTX 5090</a>
                                        </p> -->
                      <!-- <p>
                        Bảo hành: tối thiểu 12 tháng
                      </p> -->
                    </td>
                  </tr>
                  <tr id="pci9">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        Card màn hình Asus ROG ASTRAL RTX 5090 32G GAMING GDDR7
                        OC
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242207uqLYF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242207uqLYF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242254LsXmF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242254LsXmF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242301CyXAF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242301CyXAF" />
                            </a>
                          </li>

                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242348OE6LF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1759832242348OE6LF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Gia98299000 }}
                      </p>
                      <p class="text_p">Bảo hành: tối thiểu 12 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        Có thể sử dụng đồng thời 2 card
                        <a target="_blank"
                          href="https://hacom.vn/card-man-hinh-asus-rog-astral-rtx-5090-32g-gaming-gddr7-oc">
                          RTX5090</a>
                      </p>

                      <p>
                        <a target="_blank"
                          href="https://ai.vimass.vn/search/Tinh-nang-ky-thuat-cua-GPU-NVidia-5090-va-A10-R1758602531677mGv?mode=view">
                          Tính năng kỹ thuật của GPU NVidia 5090 và A10
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://ai.vimass.vn/search/He-dieu-hanh-CUDA-cua-NVIDIA-va-Bo-thu-vien-ma-nguon-mo-CUDA-su-dung-hieu-qua-nhat-voi-GPU-NVIDIA-RTX-5070-va-RTX-5090-R17586023554405lb?mode=view">
                          Hệ điều hành CUDA của NVIDIA và Bộ thư viện mã nguồn
                          mở CUDA với GPU NVIDIA RTX 5070 và RTX 5090</a>
                      </p>
                      <!-- <p>
                        Bảo hành: tối thiểu 12 tháng
                      </p> -->
                    </td>
                  </tr>

                  <tr id="camera">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600" v-html="currentLanguage.body_text_thietbi_tb_CameraHikvision
                        "></p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754903273404SShlF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754903273404SShlF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754903352357yK96F"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754903352357yK96F" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Giacamera }}
                      </p>
                      <p class="text_p">Bảo hành: tối thiểu 12 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000077138/DS-2CD1T43G2-LIUF_SL_Datasheet_20230811.pdf">
                          - Chuẩn nén hình ảnh: H.265+, H.265, H.264+, H.264
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000077138/DS-2CD1T43G2-LIUF_SL_Datasheet_20230811.pdf">
                          - Hồng ngoại lên đến 50m, ánh sáng trắng 50m
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000077138/DS-2CD1T43G2-LIUF_SL_Datasheet_20230811.pdf">
                          - Cảm biến 1/3″ Progressive Scan CMOS
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000077138/DS-2CD1T43G2-LIUF_SL_Datasheet_20230811.pdf">
                          - Thông số kỹ thuật
                        </a>
                      </p>
                    </td>
                  </tr>
                  <tr id="camera1">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600" v-html="currentLanguage.body_text_thietbi_tb_CameraHikvision1
                        "></p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1758708481507abEkF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1758708481507abEkF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Giacamera1 }}
                      </p>
                      <p class="text_p">Bảo hành: 24 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000052499/Datasheet-of-DS-2DE4215IW-DET5_V5.7.1_20220704.pdf">
                          - Chuẩn nén hình ảnh: H.265+, H.265, H.264+, H.264
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000052499/Datasheet-of-DS-2DE4215IW-DET5_V5.7.1_20220704.pdf">
                          - Hồng ngoại, tầm quan sát lên đến 100m
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000052499/Datasheet-of-DS-2DE4215IW-DET5_V5.7.1_20220704.pdf">
                          - 1/2.8 inch progressive scan CMOS
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000052499/Datasheet-of-DS-2DE4215IW-DET5_V5.7.1_20220704.pdf">
                          - Thông số kỹ thuật
                        </a>
                      </p>
                    </td>
                  </tr>
                  <tr id="camera2">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600" v-html="currentLanguage.body_text_thietbi_tb_CameraHikvision2
                        "></p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1758708817925wOuaF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1758708817925wOuaF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Giacamera2 }}
                      </p>
                      <p class="text_p">Bảo hành: 24 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000048584/DS-2DE7A232IW-AEBT5_Datasheet_V5.7.0_20240220.pdf">
                          - Chuẩn nén hình ảnh: H.265+/H.265/H.264+/H.264/MJPEG
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000048584/DS-2DE7A232IW-AEBT5_Datasheet_V5.7.0_20240220.pdf">
                          - Hồng ngoại: lên đến 200 mét
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000048584/DS-2DE7A232IW-AEBT5_Datasheet_V5.7.0_20240220.pdf">
                          - 1/2.8 inch progressive scan CMOS
                        </a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://assets.hikvision.com/prd/public/all/doc/m000048584/DS-2DE7A232IW-AEBT5_Datasheet_V5.7.0_20240220.pdf">
                          - Thông số kỹ thuật
                        </a>
                      </p>
                    </td>
                  </tr>
                  <tr id="tfluna">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600" v-html="currentLanguage.body_text_thietbi_tb_TFLuna">
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754904206294MSpcF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754904206294MSpcF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754904132869DhzSF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1754904132869DhzSF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_GiaTFLUNA }}
                      </p>
                      <p class="text_p">Bảo hành: tối thiểu 12 tháng</p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a target="_blank" href="https://en.benewake.com/TFLuna/index.html">
                          - Thông số kỹ thuật
                        </a>
                      </p>
                    </td>
                  </tr>
                  <!--  may tram tai xa core i9 card 5090-->
                  <!-- <tr>
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600"
                        v-html="currentLanguage.body_text_thietbi_tb_MaytinCPUI9">

                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751612874965hcutF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751612874965hcutF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Gia139950000 }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhbanam }}
                      </p>
                    </td>
                    <td colspan="2" rowspan="3" class="td_tb_3_1" style="vertical-align: middle;line-height: 50px;">
                      <div style="display: flex; height: 100%; min-height: 100%; flex-direction: column;">
                        <p><strong>{{ currentLanguage.body_text_thietbi_tb_CauHinhChung }}</strong></p>
                        <p>
                          <a target="_blank"
                            href="https://hacom.vn/cpu-intel-core-ultra-9-285k-up-to-5.5ghz-24-nhan-24-luong-36mb-cache-125w-socket-intel-lga-1851-arrow-lake">{{
                              currentLanguage.body_text_thietbi_tb_CPUINTELCOREI9
                            }}</a>
                        </p>
                        <p>
                          <a target="_blank" href="https://hacom.vn/mainboard-asus-tuf-gaming-z890-plus-wifi-ddr5">
                            {{
                              currentLanguage.body_text_thietbi_tb_MAINBOARDI9
                            }}</a>
                        </p>
                        <p>
                          <a target="_blank"
                            href="https://hacom.vn/ram-corsair-vengeance-rgb-64gb-ddr5-6000mhz-cmh64gx5m2b6000c38">
                            {{
                              currentLanguage.body_text_thietbi_tb_RAMCORSAIR
                            }}</a>
                        </p>
                        <p>
                          <a target="_blank"
                            href="https://hacom.vn/o-cung-ssd-kingston-snv3s-1tb-m.2-2280-pcie-gen4-x4">
                            {{
                              currentLanguage.body_text_thietbi_tb_SSDKingstonx2
                            }}</a>
                        </p>
                        <p>
                          <a target="_blank"
                            href="https://hacom.vn/nguon-asus-tuf-gaming-1200w-gold-atx3.0-pci-gen-5.0-80-plus-gold-mau-den-full-modular">
                            {{
                              currentLanguage.body_text_thietbi_tb_NGUONMAYTINHASUS
                            }}</a>
                        </p>
                        <p>
                          <a target="_blank" href="https://hacom.vn/tan-nhiet-nuoc-corsair-nautilus-360-argb-black">
                            {{
                              currentLanguage.body_text_thietbi_tb_TANNHIETNUOC
                            }}</a>
                        </p>
                        <p>
                          <a target="_blank" href="https://hacom.vn/vo-case-xigmatek-osiris-pro-4fx-eatx-4fan">{{
                            currentLanguage.body_text_thietbi_tb_VOCASE4FX }}</a>
                        </p>

                      </div>

                    </td>
                  </tr> -->

                  <!--  may tram tai xa core i9 card 5080-->
                  <!-- <tr id="pci9">
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600"
                        v-html="currentLanguage.body_text_thietbi_tb_MaytinCPUI9_card5080">
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751612328995yo18F"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751612328995yo18F" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_GiaMaytinCPUI9_card5080 }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhbanam }}
                      </p>
                    </td>

                  </tr> -->

                  <!--  may tram tai xa core i9 ko card -->
                  <!-- <tr>
                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{ currentLanguage.body_text_thietbi_tb_MaytinCPUI9_koCard }}
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441340329AkrTF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441368839v3UdF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751441447605tMzLF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514416644380iebF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_GiaMaytinCPUI9_koCard }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhbanam }}
                      </p>
                    </td>

                  </tr> -->

                  <!-- may HPE DL 380 -->
                  <!-- <tr id="maychuhp">

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        <a href="https://www.hpe.com/psnow/downloadDoc/HPE%20ProLiant%20DL380%20Gen10%20Server-a00008180enw.pdf?id=a00008180enw&isFutureVersion=true&ver=73&form=false&preview=false&print=&servePdfFile=true&hf=regular&r=&section=&prelaunchSection=&softrollSection=&deepLink=&utm_source=&utm_medium=&utm_campaign=&utm_content=&utm_term=&isLinearized=false&contentDisposition=attachment"
                          target="_blank">
                          {{ currentLanguage.body_text_thietbi_tb_MaytinhHPE }}
                        </a>
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751447020556xBq6F"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751447020556xBq6F" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751447123239kSqWF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751447123239kSqWF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751447147047GalSF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1751447147047GalSF" />
                            </a>
                          </li>
                          <li>
                            <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514476834729B1sF"
                              target="_blank">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17514476834729B1sF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_Gia260772600 }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhbanam }}
                      </p>
                    </td>
                    <td colspan="2" class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://www.sieuthimaychu.vn/index.php/Thong_Tin_San_Pham/9453/Intel%C2%AE-Xeon%C2%AE-Gold-6138-Processor-27.5M-Cache,-2.00-GHz">{{
                            currentLanguage.body_text_thietbi_tb_CPUXEON
                          }}</a>
                      </p>

                      <p>
                        <a target="_blank"
                          href="https://www.sieuthimaychu.vn/index.php/Thong_Tin_San_Pham/13127/Bo-Nho-RAM-DDR4-32GB-PC4-23466-2933MHz-ECC-Registered-DIMM">
                          {{
                            currentLanguage.body_text_thietbi_tb_RAMDDR4
                          }}</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.sieuthimaychu.vn/index.php/Thong_Tin_San_Pham/10962/O-Cung-SSD-Intel%C2%AE-DC-P4510-Series-1.0TB-2.5inch-PCIe-3.1-x4-3D2-TLC">
                          {{
                            currentLanguage.body_text_thietbi_tb_SSDINTEL
                          }}</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.sieuthimaychu.vn/index.php/Thong_Tin_San_Pham/3729/HP-Ethernet-1Gb-4-port-331T-Adapter">
                          {{
                            currentLanguage.body_text_thietbi_tb_CARDMANG
                          }}</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.sieuthimaychu.vn/index.php/Thong_Tin_San_Pham/9630/Smart-Array-HPE-P408i-a-SR-Gen10-(8-Internal-Lanes/2GB-Cache)-12G-SAS-Modular-Controller">
                          {{
                            currentLanguage.body_text_thietbi_tb_RAIN
                          }}</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.sieuthimaychu.vn/index.php/Thong_Tin_San_Pham/18991/Bo-Nguon-HP-DL160-G8-500W-Power-Supply-671797-001">
                          {{
                            currentLanguage.body_text_thietbi_tb_PSU
                          }}</a>
                      </p>
                    </td>
                  </tr> -->

                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_ThietbiphatUHFculy7mxuly1theUHFva20theUHF
                        }}
                      </p>
                      <div style="display: flex; justify-content: center">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356388146eBUqF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702356388146eBUqF" />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT2500000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <!-- <p>
                        <a
                          target="_blank"
                          href="https://vimass.vn/vmbank/services/media/viewFile?id=R16-7DB.pdf"
                          >{{
                            currentLanguage.body_text_thietbi_tb_thongsokythuat
                          }}</a
                        >
                      </p> -->

                      <p>
                        <a target="_blank"
                          href="https://drive.google.com/file/d/1O-pFpAqIckvn-tOUXZgN2uPGEwCNPPeA/view?usp=sharing">{{
                            currentLanguage.body_text_thietbi_tb_ThongsokythuatthietbithuphatUHFculy7mxuly1the
                          }}</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://drive.google.com/file/d/1mYhvUA0CAukfn4Rggb4t5c-rpAqtIcnA/view?usp=sharing">{{
                            currentLanguage.body_text_thietbi_tb_ThongsokythuatthietthubiphatUHFculy7mxuly200the
                          }}</a>
                      </p>
                    </td>
                    <td class="td_tb_4_1"></td>
                  </tr>

                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_ThietbiphatUHFculy20mxuly1theUHFva200theUHF
                        }}
                      </p>
                      <div style="display: flex; justify-content: center">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454671170N9wFF">
                              <img loading="lazy" width="100px"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454671170N9wFF" />
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT4400000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhmotnam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <!-- <p>
                        <a
                          target="_blank"
                          href="https://vimass.vn/vmbank/services/media/viewFile?id=R16-12dbi%20uhf%20rfid%20reader.pdf"
                          >{{
                            currentLanguage.body_text_thietbi_tb_thongsokythuatthietbithuphatUHF
                          }}</a
                        >
                      </p> -->
                      <p>
                        <a target="_blank"
                          href="https://drive.google.com/file/d/1gLlAcoux03Z6pavBx-0mtzS2KsW0UTKe/view?usp=sharing">{{
                            currentLanguage.body_text_thietbi_tb_ThongsokythuatthietbithuphatUHFculy20mxuly1the
                          }}</a>
                      </p>
                      <!-- <p>
                        <a
                          target="_blank"
                          href="https://vimass.vn/vmbank/services/media/viewFile?id=thong_so_ky_thuat_100_200tag_20m.pdf"
                          >{{
                            currentLanguage.body_text_thietbi_tb_ThongsokythuatthietbithuphatUHFculy20mxuly200the
                          }}</a
                        >
                      </p> -->
                    </td>

                    <td class="td_tb_4_1"></td>
                  </tr>

                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_ThekysoACSACOS564
                        }}
                      </p>
                      <div class="d-flex">
                        <ul class="gallery flex">
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670654JoWZF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670654JoWZF" />
                            </a>
                          </li>

                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670748GGsbF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670748GGsbF" />
                            </a>
                          </li>
                          <li>
                            <a target="_blank"
                              href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670842OkysF">
                              <img loading="lazy"
                                src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454670842OkysF" />
                            </a>
                          </li>
                        </ul>
                      </div>

                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT50000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1">
                      <p>
                        <a target="_blank"
                          href="https://www.acs.com.hk/en/products/308/acos5-64-v3_00-cryptographic-card-contact/">{{
                            currentLanguage.body_text_thietbi_tb_UngdungcuachipkysoACOS564
                          }}
                        </a>
                      </p>
                      <p>
                        {{
                          currentLanguage.body_text_thietbi_tb_Chitiettunhasanxuat
                        }}
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.acs.com.hk/en/corporate-social-responsibility/">https://www.acs.com.hk/en/corporate-social-responsibility/</a>
                      </p>
                      <p>
                        <a target="_blank"
                          href="https://www.acs.com.hk/en/awards-recognitions/">https://www.acs.com.hk/en/awards-recognitions/</a>
                      </p>
                    </td>
                    <td class="td_tb_4_1">
                      <p>
                        <a href="https://drive.google.com/file/d/1LhacoWR7hT4K3nc0BG_xvDHlcElGmPFp/view?usp=sharingf"
                          target="_blank">-
                          {{
                            currentLanguage.body_text_thietbi_tb_Tinhnangkythuat
                          }}</a>
                      </p>
                      <p>
                        <a href="https://drive.google.com/file/d/1xTNk7ufuGLsjg60IZKdvmkO4cHM8Z072/view?usp=sharing"
                          target="_blank">{{
                            currentLanguage.body_text_thietbi_tb_Chinhsachbaomat
                          }}</a>
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_DaunoikhongdayVimassUSBTypeA
                        }}
                      </p>
                      <ul class="gallery flex">
                        <li>
                          <!-- <a target="_blank" href="@routes_Assets_at("images/daunoivimass4_jpg}}">
                                                <img loading="lazy" src="@routes_Assets_at("images/daunoivimass4_jpg}}">
                                            </a> -->
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454669857NE1KF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454669857NE1KF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT100000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1"></td>
                    <td class="td_tb_4_1"></td>
                  </tr>
                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_Daunoicoday1mVimassUSBTypeA1khedocthe
                        }}
                      </p>
                      <ul class="gallery flex">
                        <li>
                          <!-- <a target="_blank" href="@routes_Assets_at("images/daunoivimass3_jpg}}">
                                                <img loading="lazy" src="@routes_Assets_at("images/daunoivimass3_jpg}}">
                                            </a> -->
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454669326lWTcF">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1702454669326lWTcF" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT100000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1"></td>
                    <td class="td_tb_4_1"></td>
                  </tr>
                  <tr>
                    <!-- <td class="td_tb_1_1">

                    </td> -->

                    <td class="td_tb_2_1">
                      <p class="text_p" style="font-weight: 600">
                        {{
                          currentLanguage.body_text_thietbi_tb_Daunoicoday1mVimassUSBTypeA1khedocthe1khedocSIM
                        }}
                      </p>
                      <ul class="gallery flex">
                        <li>
                          <!-- <a target="_blank" href="@routes_Assets_at("images/daunoivimass2_jpg}}">
                                                <img loading="lazy" src="@routes_Assets_at("images/daunoivimass2_jpg}}">
                                            </a> -->
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17023563868180ef6F">
                            <img loading="lazy"
                              src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17023563868180ef6F" />
                          </a>
                        </li>
                      </ul>
                      <p class="text_p">
                        {{
                          currentLanguage.body_text_thietbi_tb_GiagomVAT100000dong
                        }}
                      </p>
                      <p class="text_p">
                        {{ currentLanguage.body_text_thietbi_tb_baohanhhainam }}
                      </p>
                    </td>
                    <td class="td_tb_3_1"></td>

                    <td class="td_tb_4_1"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- tieu hoc-->
          <div id="DaiLy" v-show="showDaiLy" style="min-height: 500px; background-image: none !important"
            class="padding-top15">
            <div class="title-bai-viet" v-html="titleDaiLy"></div>
            <div v-html="contentDaiLy"></div>
          </div>
        </main>
      </div>
    </main>
  </div>
</template>

<script>
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      activeTab: "ThietBiTab",

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      //show
      showThietBiTab: true,
      showDaiLy: false,

      //active tab
      isActiveThietBiTab: true,
      isActiveDaiLy: false,

      //title
      titleDaiLy: "",

      //content
      contentDaiLy: "",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("languages") || "vi";
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result_title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store content separately for each section
        if (section === "DaiLy") {
          this.titleDaiLy = decodeURIComponent(escape(title));
          this.contentDaiLy = decodeURIComponent(escape(decodedString));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      this.lang = localStorage.getItem("languages") || "vi";

      if (tab === "ThietBiTab") {
        this.isActiveThietBiTab = true;
        this.isActiveDaiLy = false;
      } else if (tab === "DaiLy") {
        this.isActiveDaiLy = true;
        this.isActiveThietBiTab = false;
        this.performPostRequest("1684299234996ruokw", "DaiLy", this.lang);
      }

      this.activeTab = tab; // Cập nhật giá trị activeTab

      this.showThietBiTab = tab === "ThietBiTab";
      this.showDaiLy = tab === "DaiLy";
    },
  },
};
</script>

<style scoped>
/* Modern Table Style */
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  overflow: hidden;
  margin-bottom: 32px;
}

td,
th {
  padding: 16px 12px;
  vertical-align: top;
  font-size: 17px;
  color: #222;
  background: #f9fbfc;
}

tr:not(:first-child):hover {
  background: #eaf6ff;
  transition: background 0.2s;
}

tr:first-child td,
tr:first-child th {
  background: #85c8eb !important;
  color: #222;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0.5px;
}

.td_tb_2_1,
.td_tb_3_1,
.td_tb_4_1 {
  border-bottom: 1px solid #e3e9ef;
}

.td_tb_2_1:last-child,
.td_tb_3_1:last-child,
.td_tb_4_1:last-child {
  border-bottom: none;
}

/* Gallery */
.gallery.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.gallery.flex li {
  list-style: none;
}

.gallery.flex img {
  max-width: 120px;
  width: 100%;
  height: auto;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e3e9ef;
  transition: transform 0.2s, border 0.2s;
  background: #fff;
}

.gallery.flex img:hover {
  transform: scale(1.07);
  border: 2px solid #85c8eb;
}

.text_p {
  margin-bottom: 10px;
  line-height: 1.7;
  color: #333;
}

@media (max-width: 1024px) {

  table,
  tbody,
  tr,
  td,
  th {
    font-size: 15px;
  }

  .gallery.flex img {
    max-width: 90px;
  }

  .text_p {
    font-size: 15px;
  }

  td,
  th {
    padding: 10px 6px;
  }
}

/* Phone: width <= 600px */
@media (max-width: 600px) {
  .tabcontent {
    overflow-x: auto;
  }

  table {
    min-width: 600px;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 16px;
    display: block;
    overflow-x: auto;
  }

  td,
  th {
    font-size: 14px;
    padding: 8px 4px;
    background: #fff;
    border: none;
    word-break: break-word;
  }

  .gallery.flex img {
    max-width: 70px;
    border-radius: 8px;
  }

  .text_p {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .urlThietBi,
  .urlDaiLy {
    font-size: 15px;
    padding: 8px 8px;
  }

  /* Ẩn header nếu muốn */
  tr:first-child {
    display: none;
  }
}

@media (max-width: 600px) {
  .tabcontent {
    overflow-x: auto;
  }

  table {
    min-width: 600px;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 16px;
    display: block;
    overflow-x: auto;
  }

  td,
  th {
    font-size: 14px;
    padding: 8px 4px;
    background: #fff;
    border: none;
    word-break: break-word;
  }

  .gallery.flex img {
    max-width: 70px;
    border-radius: 8px;
  }

  .text_p {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .urlThietBi,
  .urlDaiLy {
    font-size: 15px;
    padding: 8px 8px;
  }

  /* Ẩn header nếu muốn */
  tr:first-child {
    display: none;
  }
}

/* Hide table header on phone */

.topmenuactive>a {
  color: #1976d2 !important;
  font-weight: bold;
  border-bottom: 2px solid #1976d2;
  background: #eaf6ff;
  border-radius: 8px 8px 0 0;
}

.urlThietBi,
.urlDaiLy {
  display: block;
  padding: 10px 18px;
  color: #222;
  text-decoration: none;
  font-size: 17px;
  transition: background 0.2s, color 0.2s;
}

.urlThietBi:hover,
.urlDaiLy:hover {
  background: #eaf6ff;
  color: #1976d2;
  border-radius: 8px 8px 0 0;
}
</style>
